import { Button, Slider, Tooltip, Typography } from "antd"

const { Text } = Typography

type Props = {
  stopCount: number
  optimizeRange: [number, number]
  onRangeChange: (range: [number, number]) => void
  onOptimize: () => void
  hasStartLocation: boolean
  hasEndLocation: boolean
}

const OptimizeRouteSection = ({ stopCount, optimizeRange, onRangeChange, onOptimize, hasStartLocation, hasEndLocation }: Props) => {
  const selectedCount = optimizeRange[1] - optimizeRange[0] + 1
  const exceedsLimit = selectedCount > 23

  const formatTooltip = (value: number | undefined) => {
    if (value === undefined) return ''
    if (value === 1 && hasStartLocation) return 'Start'
    if (value === stopCount && hasEndLocation) return 'End'
    return `Stop ${value}`
  }

  if (stopCount <= 23) {
    return (
      <Tooltip title="Optimize route for shortest drive time">
        <span style={{ flex: 1 }}>
          <Button
            id="optimize-drive-time-button"
            type="default"
            block
            onClick={onOptimize}
          >
            Optimize Drive Time
          </Button>
        </span>
      </Tooltip>
    )
  }

  return (
    <div style={{ flex: 1 }}>
      <Tooltip title={exceedsLimit ? "Select 23 or fewer stops" : "Optimize selected stops for shortest drive time"}>
        <span>
          <Button
            id="optimize-drive-time-button"
            type="default"
            block
            onClick={onOptimize}
            disabled={exceedsLimit}
          >
            Optimize Drive Time
          </Button>
        </span>
      </Tooltip>
      <div style={{ marginTop: 12 }}>
        <Text type="secondary" style={{ fontSize: 12 }}>
          Select stops to optimize (max 23)
        </Text>
        <Slider
          range
          min={1}
          max={stopCount}
          value={optimizeRange}
          onChange={(value) => onRangeChange(value as [number, number])}
          tooltip={{ formatter: formatTooltip }}
          style={{ marginTop: 4 }}
        />
        <Text type={exceedsLimit ? 'danger' : 'secondary'} style={{ fontSize: 12 }}>
          {formatTooltip(optimizeRange[0])} - {formatTooltip(optimizeRange[1])} ({selectedCount} stops)
          {exceedsLimit && ' - exceeds limit'}
        </Text>
      </div>
    </div>
  )
}

export default OptimizeRouteSection
